@file:Suppress("UnsafeCastFromDynamic")

package index

import bm.app
import react.dom.render
import kotlinx.browser.document
import kotlinext.js.requireAll

// TODO ALC favicon

fun main(args: Array<String>) { // don't remove the args or the app won't work
    requireAll(kotlinext.js.require.context("src", true, js("/\\.css$/")))

    render(document.getElementById("root")) {
        app()
    }
}
